import { HeroId, HERO_COUNT } from "../../../shared/src/index.ts";
import type { VoiceScript } from "./voice-types.ts";
import v0 from "./captain-americano/voice.ts";
import v1 from "./doctor-estranged/voice.ts";
import v2 from "./root/voice.ts";
import v3 from "./the-bulk/voice.ts";
import v4 from "./magnetron/voice.ts";
import v5 from "./penny-parka/voice.ts";
import v6 from "./thud/voice.ts";
import v7 from "./venison/voice.ts";
import v8 from "./black-panthera/voice.ts";
import v9 from "./black-window/voice.ts";
import v10 from "./squawkeye/voice.ts";
import v11 from "./hella/voice.ts";
import v12 from "./irony-fist/voice.ts";
import v13 from "./ion-man/voice.ts";
import v14 from "./tragik/voice.ts";
import v15 from "./noon-knight/voice.ts";
import v16 from "./sub-marinara/voice.ts";
import v17 from "./psyclone/voice.ts";
import v18 from "./scarlet-twitch/voice.ts";
import v19 from "./cider-man/voice.ts";
import v20 from "./squirrely-girl/voice.ts";
import v21 from "./star-lorde/voice.ts";
import v22 from "./brainstorm/voice.ts";
import v23 from "./the-punnisher/voice.ts";
import v24 from "./winter-shoulder/voice.ts";
import v25 from "./woolverine/voice.ts";
import v26 from "./atom-warlock/voice.ts";
import v27 from "./cloak-and-swagger/voice.ts";
import v28 from "./geoff/voice.ts";
import v29 from "./lowkey/voice.ts";
import v30 from "./luna-snowcone/voice.ts";
import v31 from "./mantissa/voice.ts";
import v32 from "./pocket-raccoon/voice.ts";

export const HERO_VOICE_SCRIPTS: Record<HeroId, VoiceScript> = {
  [HeroId.CaptainAmericano]: v0,
  [HeroId.DoctorEstranged]: v1,
  [HeroId.Root]: v2,
  [HeroId.Bulk]: v3,
  [HeroId.Magnetron]: v4,
  [HeroId.PennyParka]: v5,
  [HeroId.Thud]: v6,
  [HeroId.Venison]: v7,
  [HeroId.BlackPanthera]: v8,
  [HeroId.BlackWindow]: v9,
  [HeroId.Squawkeye]: v10,
  [HeroId.Hella]: v11,
  [HeroId.IronyFist]: v12,
  [HeroId.IonMan]: v13,
  [HeroId.Tragik]: v14,
  [HeroId.NoonKnight]: v15,
  [HeroId.SubMarinara]: v16,
  [HeroId.Psyclone]: v17,
  [HeroId.ScarletTwitch]: v18,
  [HeroId.CiderMan]: v19,
  [HeroId.SquirrelyGirl]: v20,
  [HeroId.StarLorde]: v21,
  [HeroId.Brainstorm]: v22,
  [HeroId.Punnisher]: v23,
  [HeroId.WinterShoulder]: v24,
  [HeroId.Woolverine]: v25,
  [HeroId.AtomWarlock]: v26,
  [HeroId.CloakSwagger]: v27,
  [HeroId.Geoff]: v28,
  [HeroId.Lowkey]: v29,
  [HeroId.LunaSnowcone]: v30,
  [HeroId.Mantissa]: v31,
  [HeroId.PocketRaccoon]: v32,
};

export const HERO_VOICE_LIST: VoiceScript[] = Object.values(HERO_VOICE_SCRIPTS);
if (HERO_VOICE_LIST.length !== HERO_COUNT) throw new Error(`expected ${HERO_COUNT} hero voice scripts, found ${HERO_VOICE_LIST.length}`);

export { VOICE_TRIGGERS } from "./voice-types.ts";
export type { VoiceFx, VoiceLine, VoiceScript, VoiceSpec, VoiceTrigger } from "./voice-types.ts";
